import { render } from "./Video.vue?vue&type=template&id=6faa4d6c&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=6faa4d6c&lang=css"
import "./Video.vue?vue&type=style&index=1&id=6faa4d6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faa4d6c"]])

export default __exports__